<div class="form-inline my-2 my-lg-0">
    <span class="bnpp-regular">Horizon: </span>

    <div class="d-inline-block horizon-dropdown-menu" [class.show]="showDropdown">
        <div class="btn-container">
            <button class="dropdown-toggle tool-bar-control" (click)="onDropdownButtonClick($event)">
                {{horizon.text}}
            </button>
            <div class="px-p-10 horizon-dropdown-menu-panel">
                <div class="d-flex flex-row">
                    <div>
                        <select [(ngModel)]="horizon.from" class=" form-select-sm"
                                (ngModelChange)="selectedValueChange($event)">
                            <option *ngFor="let item of defaultTimeRangeList" [ngValue]="item.value">
                                {{item.text}}
                            </option>
                        </select>
                    </div>
                    <div class="px-px-10">to</div>
                    <div>
                        <select [(ngModel)]="horizon.to" class=" form-select-sm"
                                (ngModelChange)="selectedValueChange($event)">
                            <option *ngFor="let item of defaultTimeRangeList" [ngValue]="item.value">
                                {{item.text}}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="d-flex flex-row-reverse px-mt-10">
                    <button type="button" class="btn btn-sm btn-basic bnpp-btn"
                            (click)="onHorizonTimeRangeUpdate(horizon)">
                        <span>UPDATE</span>
                    </button>
                </div>
            </div>
        </div>

    </div>
</div>
